import styles from './ResultQuiz.module.css';
import { motion } from 'motion/react';
import { Counter } from './Title';

export const ResultQuiz = ({ correctVar, notCorrectVar }) => {
  const { comment } = correctVar || {};

  const arrTitle = comment?.trim()?.split(' ');

  return (
    <div className={styles.wrapper}>
      {comment && (
        <div className={styles.titleWrapper}>
          <div className={styles.secondName}>
            <motion.div
              initial={{ scale: 0, opacity: 1 }}
              animate={{ scale: [0, 1.2, 1, 1.8], opacity: 0 }}
              transition={{
                scale: {
                  times: [0, 0.5, 0.6, 1],
                  duration: 1.2,
                  delay: 0.5,
                },
                opacity: {
                  duration: 0.6,
                  delay: 0.5 + 0.57,
                },
              }}
              className={styles.borderTitle}
            />

            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: [0, 1.28, 1] }}
              transition={{
                duration: 0.9,
                delay: 0.5,
                times: [0, 0.8, 1],
              }}
            >
              <Counter
                vars={[...notCorrectVar?.slice(0, 4), arrTitle?.[0]]}
                correct={arrTitle?.[0]}
              />
            </motion.div>
          </div>
          <motion.div
            initial={{ scale: 0, color: '#FFB736', y: '-8rem' }}
            animate={{
              scale: [0, 1, 0.8, 1],
              color: ['#FFB736', '#FFFFFF', '#FFB736'],
            }}
            transition={{
              scale: {
                duration: 0.8,
                delay: 0.5 + 1.2,
                times: [0, 0.5, 0.75, 1],
              },
              color: {
                duration: 0.4,
                delay: 0.5 + 1.2 + 0.4,
                times: [0, 0.5, 1],
              },
            }}
            className={styles.firstName}
          >
            {arrTitle[1]}
          </motion.div>
        </div>
      )}
    </div>
  );
};
